import React from 'react'
import Icon from '../../../../atoms/Icon'

function SystemTag () {
  return (
    <div
      className='flex gap-sm radius-sm'
      style={{
        borderColor: 'var(--color-neutral-600)',
        borderWidth: '1px',
        borderStyle: 'solid',
        padding: 'var(--padding-xs) var(--padding-sm)',
        backgroundColor: 'var(--color-neutral-700)',
        color: 'var(--color-contrast-neutral-700)'
      }}
    >
      <Icon name='storage' style={{ fontSize: '16px' }} />
      <span>System</span>
    </div>
  )
}

export default SystemTag
